import base64 from 'react-native-base64';
import { firebase } from '../config/configureFirebase';
import AccessKey from './ApiAccessKey';

// Diagnostics object to expose last error/status from server calls to the UI
export const PlacesDiag = { last: null };

export const fetchPlacesAutocomplete = (searchKeyword) => {
    return new Promise((resolve,reject)=>{
        const { config } = firebase;
        PlacesDiag.last = null;
        const hostBase = `https://${config.projectId}.web.app`;

        // Add timeout to fetch request
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 15000);

        fetch(`${hostBase}/googleapis-autocomplete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": "Basic " + base64.encode(config.projectId + ":" + AccessKey),
                "x-api-key": AccessKey
            },
            body: JSON.stringify({
                "searchKeyword": searchKeyword
            }),
            signal: controller.signal
        }).then(async response => {
            clearTimeout(timeoutId);
            // Check if response is ok
            if (!response.ok) {
                console.log('Places API HTTP error:', response.status, response.statusText);
                PlacesDiag.last = { source:'http', status: response.status, message: response.statusText };
            }
            try { return await response.json(); } catch(e){
                console.log('Places API JSON parse error:', e);
                return { error: 'invalid_json' };
            }
        })
        .then(async json => {
            if(json && json.searchResults && json.searchResults.length) {
                PlacesDiag.last = null;
                return resolve(json.searchResults);
            }
            if(json && json.error){
                console.log('Places API error:', json.error, json.error_message || '');
                PlacesDiag.last = { source:'server', status: json.status || null, error_message: json.error_message || json.error };
            }
            resolve([]);
        }).catch(async error=>{
            clearTimeout(timeoutId);
            console.log('Places API fetch error:', error.name, error.message);
            PlacesDiag.last = { source:'network', message: (error && error.message) ? error.message : 'network_error' };
            resolve([]);
        })
    });
}

export const fetchCoordsfromPlace = (place_id) => {
    return new Promise((resolve,reject)=>{
        const { config } = firebase;
        const hostBase = `https://${config.projectId}.web.app`;

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 15000);

        fetch(`${hostBase}/googleapis-getcoords`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": "Basic " + base64.encode(config.projectId + ":" + AccessKey),
                "x-api-key": AccessKey
            },
            body: JSON.stringify({
                "place_id": place_id
            }),
            signal: controller.signal
        }).then(async response => {
            clearTimeout(timeoutId);
            if (!response.ok) {
                console.log('GetCoords API HTTP error:', response.status, response.statusText);
            }
            try { return await response.json(); } catch(e){
                console.log('GetCoords API JSON parse error:', e);
                return { error:'invalid_json'};
            }
        })
        .then(json => {
            if(json && json.coords) {
                resolve(json.coords);
            }else{
                console.log('GetCoords API no coords returned:', json?.error || 'unknown');
                resolve(null);
            }
        }).catch(error=>{
            clearTimeout(timeoutId);
            console.log('GetCoords API fetch error:', error.name, error.message);
            resolve(null);
        })
    });
}


export const fetchAddressfromCoords = (latlng) => {
    return new Promise((resolve,reject)=>{
        const { config } = firebase;
        const hostBase = `https://${config.projectId}.web.app`;
        fetch(`${hostBase}/googleapis-getaddress`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": "Basic " + base64.encode(config.projectId + ":" + AccessKey),
                "x-api-key": AccessKey
            },
            body: JSON.stringify({
                "latlng": latlng
            })
        }).then(async response => { try { return await response.json(); } catch(e){ return { error:'invalid_json'} } })
        .then(json => {
            if(json && json.address) {
                resolve(json.address);
            }else{
                resolve(null);
            }
        }).catch(error=>{
            console.log(error);
            resolve(null);
        })
    });
}

export const getDistanceMatrix = (startLoc, destLoc) => {
    return new Promise((resolve,reject)=>{
        const { config } = firebase;
        const hostBase = `https://${config.projectId}.web.app`;
        fetch(`${hostBase}/googleapis-getdistancematrix`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": "Basic " + base64.encode(config.projectId + ":" + AccessKey),
                "x-api-key": AccessKey
            },
            body: JSON.stringify({
                "start": startLoc,
                "dest": destLoc
            })
        }).then(async response => { try { return await response.json(); } catch(e){ return { error:'invalid_json'} } })
        .then(json => {
            if(json && !json.error){
                resolve(json);
            }else{
                resolve([]);
            }
        }).catch(error=>{
            console.log(error);
            resolve([]);
        })
    });
}

export const getDirectionsApi = (startLoc, destLoc, waypoints) => {
    return new Promise((resolve,reject)=>{
        const { config } = firebase;
        const body = {
            "start": startLoc,
            "dest": destLoc
        };
        if(waypoints){
            body["waypoints"] = waypoints;
        }
        const hostBase = `https://${config.projectId}.web.app`;
        fetch(`${hostBase}/googleapis-getdirections`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": "Basic " + base64.encode(config.projectId + ":" + AccessKey),
                "x-api-key": AccessKey
            },
            body: JSON.stringify(body)
        }).then(async response => { try { return await response.json(); } catch(e){ return { error:'invalid_json'} } })
        .then(json => {
            if (json && json.hasOwnProperty('distance_in_km')) {
                resolve(json);
            }else{
                console.log(json.error);
                resolve({ distance_in_km: 0, time_in_secs: 0, polylinePoints: ''});
            }
        }).catch(error=>{
            console.log(error);
            resolve({ distance_in_km: 0, time_in_secs: 0, polylinePoints: ''});
        })
    });
}
